export default "__VITE_ASSET__CLees0xc__"